/**
 * Licensee User Validation Config
 */

define(function(require) {
    'use strict';

    const i18n = require('i18n');
    var $ = require('j');
    var _ = require('underscore');
    const userValidationConfig = require('modules/user/spanish-regulations/user.validation.config');
    const validationUtil = require('./user.validation.util');
    const { getSpanishNameValidationConfig, checkDNI, checkNIE } = validationUtil;
    const firstNameRe = /^[A-Za-záéíóúÁÉÍÓÚàèïòüÀÈÏÒÜÑñÇç«»€õöÖÄß,.'\s\-]+$/;

    /**
     * [validatePassword - regexp for validation password]
     * @param  {[String]} val [Input value]
     * @return {boolean}     [Is value vaild or not]
     */
    const validatePassword = (val) => {
        let symbolsCount = 0;

        function testRegExp(regexp) {
            new RegExp(regexp).test(val) && symbolsCount++;
        }

        testRegExp('[A-Z]+');
        testRegExp('[a-z]+');
        testRegExp('\\d+');
        testRegExp('[.@_#$\'&+()*`;!?,-/\]+');

        return symbolsCount > 2;
    };

    return () => {
        const config = userValidationConfig();

        // userName
        config.userName.length.min = 6;
        config.userName.length.max = 10;

        /**
         * Nombre
         * Primer Apellido
         * Segundo Apellidos
         * Ciudad +
         * Dirección +
         * Contraseña +
         * Confirmar password +
         * Pregunta secreta +
         * Respuesta secreta +
         */

        //address
        config.address.regexp.regexp = /^[A-Za-záéíóúÁÉÍÓÚàèïòüÀÈÏÒÜÑñÇç«»€0-9.'#&\/\\\s\-]+$/;

        /**
         * @override
         * @param $inputs
         * @param config
         * @param form
         * @returns {boolean}
         */
        config.city.fn = {
            fn: function($inputs) { // eslint-disable-line
                var city = $inputs.val().trim();

                if (city.indexOf('-') !== -1 && city[0] !== '-') {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.city.regexp.1');
                    return false;
                }
                if (city.indexOf(',') !== -1 && city[0] === ',') {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.city.regexp.2');
                    return false;
                }
                if (!/^[A-Za-záéíóúÁÉÍÓÚàèïòüÀÈÏÒÜÑñÇç«»€0-9\-.,'\s]+$/.test(city)) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.city.regexp');
                    return false;
                }

                return true;
            }
        };

        config.password.regexp = {
            regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*((\d)|([_.\-@#$'&+()*`;!?,])))[A-Za-z\.\@\_\#\$\'\&\+\(\)\*\`\;\!\?\,\-\/\d]{8,10}$/,
            message: i18n.t('playtech.mobile.system.user.tooltip.password.regexp')
        };
        config.password.length = {
            min: 8,
            max: 10,
            message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
        };

        /**
         * @override
         * @param $inputs
         * @param cfg
         * @param form
         * @returns {boolean}
         */
        config.passwordSpanish.fn.fn = function($inputs, cfg, form) {
            var $formContainer = form.$el.parents('.fn-register-content'),
                password = $inputs[0].value,
                userName = form.data('userName'),
                day = $formContainer.find('#day')[0].value,
                month = $formContainer.find('#month')[0].value,
                year = $formContainer.find('#year')[0].value,
                firstName = $formContainer.find('.fn-full-first-name')[0].value,
                lastName = $formContainer.find('.fn-full-first-surname')[0].value,
                secondLastName = $formContainer.find('.fn-full-second-surname')[0].value,
                forbidden = [
                    day + month,
                    day + month + year,
                    day + month + year.substr(2, 4),
                    userName.toLowerCase(),
                    firstName.toLowerCase(),
                    lastName.toLowerCase(),
                    secondLastName.toLowerCase()
                ].filter(function(entry) { return entry; });

            /**
             * Password requirements
             * 1) at least 8 characters
             * 2) contains upper and lower case characters
             * 3) contains alphabetic and numeric characters
             * 4) contains special characters .@_#$/'&+()*`;!?,-
             */

            /* Related to SP-420 */
            // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.@_#$\/'&+()*`;!?,-])[a-zA-ZáéíóúÁÉÍÓÚàèïòüÀÈÏÒÜÑñÇç«»€0-9.@_#$\/'&+()*`;!?,-]{8,}$/
            if (!validatePassword($inputs[0].value)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.passwordSportium.regexp');
                return false;
            } else if (forbidden.filter(function(forbiddenEntry) {
                return password.toLowerCase().indexOf(forbiddenEntry) !== -1;
            }).length > 0) {

                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.passwordContainsData');
                return false;
            }

            return true;
        };

        config.passwordSpanish.length = {
            min: 8,
            max: 10,
            message: i18n.t('playtech.mobile.system.user.tooltip.passwordSportium.length')
        };

        /**
         * @override
         * @param $inputs
         * @param config
         * @param form
         * @param dfd
         * @param event
         * @param data
         * @returns {boolean}
         */
        config.secondSurname.fn.fn = function($inputs, config, form, dfd, event, data) { // eslint-disable-line
            var citizenship = form.data('citizenship') || Playtech.fetchUserDetails().citizenship,
                lastSurnameValue = $inputs[0].value || '';

            if (citizenship && citizenship !== 'ES') {
                return true; // not required for non-spanish, but must still be valid if entered
            } else if (lastSurnameValue && !/^[A-Za-züõöÖÄß,\.\'\s\-]+$/.test(lastSurnameValue)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp');
                return false;
            } else if (lastSurnameValue.length > 40) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameLong');
                return false;
            } else if (!lastSurnameValue) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameRequired');
                return false;
            } else if (lastSurnameValue.length < 2) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.secondSurnameShort');
                return false;
            }

            return true;
        };

        config.firstName = getSpanishNameValidationConfig(
            'playtech.mobile.system.user.tooltip.spanish.nameShort',
            'playtech.mobile.system.user.tooltip.spanish.nameLong',
            'playtech.mobile.system.user.tooltip.spanish.nameRequired',
            firstNameRe
        );

        config.firstSurname = getSpanishNameValidationConfig(
            'playtech.mobile.system.user.tooltip.spanish.firstSurnameShort',
            'playtech.mobile.system.user.tooltip.spanish.firstSurnameLong',
            'playtech.mobile.system.user.tooltip.spanish.firstSurnameRequired',
            firstNameRe
        );

        config.fullFirstName = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.fullFirstName.required')
            }
        };
        config.fullFirstSurname = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.fullFirstSurname.required')
            }
        };

        config.personalId.fn.fn = function($inputs, cfg, form, dfd, event, data) {
            var $formContainer = form.$el.parents('.fn-register-content');
            var countrycode = $formContainer.find('.fn-country');
            var citizenship = form.data('citizenship') || data.citizenship;
            var country = countrycode[0] && countrycode[0].value || data.country;
            var personalId = $inputs[0].value || '';

            if (country !== 'ES' &&
                (citizenship !== 'ES' || citizenship === 'ES' && personalId === '')) {
                return true;
            } else if (personalId.length > 9) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdLong');
                return false;
            } else if (personalId.length < 9) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdShort');
                return false;
            }

            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanish.personalIdInvalid');
            return citizenship === 'ES' ?
                checkDNI(personalId) : country === 'ES' ? checkNIE(personalId) : true;
        };

        var isZeroAndIsInput = function(value, isInputType) {
            var isInvalidValue = !value && value !== 0;
            var isZeroValue = value === 0 && isInputType;
            return !(isInvalidValue || isZeroValue);
        };

        var isZeroAndIsDropdown = function(value, isInputType) {
            return value === 0 && !isInputType;
        };

        var isFitLimitAmount = {
            'session': function(data, isInputType) {
                var value = data.session;
                // deposit limit has editable dropdown type
                // 'isInputType' param use for loss/bet limits
                var isDepositLimit = _.isUndefined(isInputType);

                if (!isDepositLimit && !isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (!isDepositLimit && isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day < value) {
                    return false;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }

                return true;
            },
            'day': function(data, isInputType) {
                var value = data.day;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'week': function(data, isInputType) {
                var value = data.week;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'month': function(data, isInputType) {
                var value = data.month;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.week && data.week > value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            }
        };
        // eslint-disable-next-line no-shadow
        config.depositLimit.fn.fn = function($inputs, config, form) {
            var options = form.options.data;
            var formData = _.isEmpty(form.data()) ? form.selectedData : form.data();
            var data = _.mapObject(formData, Number);
            var fieldName = $inputs[0].name;
            var value = Number($inputs.val());
            var viewFieldTypesMatchStr = 'daydeposit|weekdeposit|monthdeposit';
            var validationFieldTypesMatchStr = 'day|week|month';
            var isQuestionnairePopup = options.type === 'questionnaire';

            // check another fields
            var fields = form.$el.find('[data-validation-type=depositLimit]');
            if (!fields.length) {
                fields = form.$el.find('.fn-deposit-limit-generic');
            }

            if (!form.validationInProgress) {
                form.validationInProgress = true;

                _.each(fields, function(field) {
                    form.validateField($(field), options);
                });

                form.validationInProgress = false;
            }
            // format to {day:, week:, month:} for easy validation
            var formattedData = _.keys(data).reduce(function(memo, limitName) {
                var matched = limitName.match(viewFieldTypesMatchStr);
                if (matched) {
                    memo[matched[0].split('deposit')[0]] = data[limitName];
                }
                return memo;
            }, {});

            // check playerMustSetLimits & allPeriodsRequired & noLimitsAllowed
            var isAllLimitsAreEmpty = function(periods) {
                return _.every(_.pairs(periods), function(pair) {
                    return pair[1] === 0;
                });
            };
            if (options.playerMustSetLimits) {
                if (options.allPeriodsRequired && value === 0) {
                    this.message = i18n.t('playtech.mobile.system.tooltip.limits.allRequired');
                    return false;
                }
                if (!options.allPeriodsRequired && isAllLimitsAreEmpty(formattedData)) {
                    this.message = i18n.t('playtech.mobile.system.tooltip.limits.oneRequired');
                    return false;
                }
            }
            if (!options.allPeriodsRequired && value === 0) {
                return true;
            }

            // check daily <= weekly <= monthly
            var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

            if (!isFitLimitAmount[currentLimitName](formattedData)) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                return false;
            }

            // check if predefinedType = 'enabled'
            if (options && options.predefinedType === 'enabled' && !isQuestionnairePopup) {
                // skip range validation for 'Unlimited' and '0'
                if (options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT) || value === 0) {
                    return true;
                }
                var allowedLimits = options.allowedLimits.map(Number);
                var isEmptyAllowed = options.playerMustSetLimits && !options.allPeriodsRequired;

                if (options.noLimitsAllowed) {
                    allowedLimits.pop();
                }

                var min = Math.min.apply(null, allowedLimits);
                var max = Math.max.apply(null, allowedLimits);

                if (value < min || value > max) {
                    var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (isEmptyAllowed
                        ? '.empty'
                        : '');
                    this.message = i18n.t(tkEnabled, min, max);
                    return false;
                }
            }
            // check for Unlimited if not permitted
            if (!options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                return false;
            }

            return true;
        };

        return config;
    };
});
